const defaultAuth0ProfileConfig = {
    auth0: {
        domain: '',
        clientId: '',
        audience: '',
        cookieDomain: '',
        redirectUri: '',
        authorizationParams: {
            scopes: []
        },
        extraCookies: [
            'idToken'
        ]
    },
    pup: {
        dataLayerName: 'purData',
        url: ''
    }
};
const defaultAuth0UtilityModalConfig = {
    auth0: {
        domain: '',
        clientId: '',
        audience: '',
        cookieDomain: '',
        redirectUri: '',
        authorizationParams: {
            scopes: []
        },
        extraCookies: [
            'idToken'
        ]
    },
    pup: {
        dataLayerName: 'purData',
        url: ''
    },
    utilityModal: {
        heading: 'Continue with Purina',
        subheading: "It's easy and convenient - create a single account to access all Purina platforms"
    }
};
const defaultPurinaProfileConfig = {
    cognito: {
        userPoolId: '',
        userPoolWebClientId: '',
        signUpVerificationMethod: 'link',
        oauth: {
            domain: '',
            redirectSignIn: '',
            redirectSignOut: '',
            scope: []
        }
    },
    pup: {
        dataLayerName: 'dataLayer',
        url: ''
    }
};
const defaultSSOUtilityModalConfig = {
    cognito: {
        userPoolId: '',
        userPoolWebClientId: '',
        signUpVerificationMethod: 'link',
        oauth: {
            domain: '',
            redirectSignIn: '',
            redirectSignOut: '',
            scope: []
        }
    },
    pup: {
        dataLayerName: 'dataLayer',
        url: ''
    },
    utilityModal: {
        heading: 'Continue with Purina',
        subheading: "It's easy and convenient - create a single account to access all Purina platforms"
    }
};
export { defaultAuth0ProfileConfig, defaultAuth0UtilityModalConfig, defaultPurinaProfileConfig, defaultSSOUtilityModalConfig };
